import { createTranslations } from '@npco/utils-translations'

export const bulletPointsBannerTranslation = createTranslations({
  point1: 'Free express shipping',
  point2: 'Same-day dispatch',
  point3: '12-month warranty',
})
